export default {

    setParticipantsByStatus(state, { data }) {
        state.participantsByStatus = data;
    }
};
